// DatenschutzPage.tsx — NEKO-hosted Datenschutz fallback page (LEGAL-02)
// Displayed when tenant has no custom Datenschutz URL configured.
// Tenant-specific Datenschutz should be configured via x-tenant-datenschutz-url meta tag.

import { Zap } from "lucide-react";

export default function DatenschutzPage() {
  return (
    <div className="min-h-screen bg-neko-dark flex flex-col">
      <header className="bg-neko-dark-2 border-b border-neko-dark-3">
        <div className="max-w-2xl mx-auto px-4 py-4 flex items-center gap-3">
          <a href="/" className="flex items-center gap-3 group cursor-pointer">
            <div className="w-10 h-10 bg-neko-orange rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-neko-orange/90 transition-colors">
              <Zap className="w-6 h-6 text-neko-dark" strokeWidth={2.5} />
            </div>
            <div>
              <span className="text-neko-white font-bold text-xl">NEKO</span>
              <span className="text-neko-gray text-sm ml-2">Bad · Wärme · Strom</span>
            </div>
          </a>
        </div>
      </header>
      <main className="max-w-2xl mx-auto px-4 py-8 flex-1 w-full animate-fade-in">
        <h1 className="text-neko-white font-bold text-2xl mb-6">Datenschutzerklärung</h1>
        <div className="text-neko-gray text-sm space-y-4 leading-relaxed">
          <section>
            <h2 className="text-neko-white font-semibold text-base mb-2">
              1. Verantwortlicher
            </h2>
            <p>NEKO Energie GmbH, info@neko-bws.de</p>
          </section>
          <section>
            <h2 className="text-neko-white font-semibold text-base mb-2">
              2. Erhobene Daten
            </h2>
            <p>
              Wir verarbeiten folgende Daten: Name, E-Mail-Adresse, optionale Telefonnummer,
              Gebäudedaten (Baujahr, Gebäudetyp, Maßnahmen) und Standortdaten
              (bei Nutzung des Dach-Mappers nach Ihrer Einwilligung).
            </p>
          </section>
          <section>
            <h2 className="text-neko-white font-semibold text-base mb-2">
              3. Rechtsgrundlage
            </h2>
            <p>
              Die Verarbeitung Ihrer Daten erfolgt auf Basis Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO)
              sowie zur Anbahnung und Erfüllung eines Vertrags (Art. 6 Abs. 1 lit. b DSGVO).
            </p>
          </section>
          <section>
            <h2 className="text-neko-white font-semibold text-base mb-2">
              4. Subprozessoren
            </h2>
            <p>
              Wir nutzen folgende Dienstleister: Supabase (Datenspeicherung, EU), Vercel (Hosting, EU),
              Resend (E-Mail-Versand), MapTiler (Geocoding und Kartenkacheln, nach Einwilligung),
              Google Solar API (Solardaten, nach Einwilligung).
            </p>
          </section>
          <section>
            <h2 className="text-neko-white font-semibold text-base mb-2">
              5. Speicherdauer
            </h2>
            <p>
              Ihre Daten werden nur so lange gespeichert, wie es für die genannten Zwecke erforderlich ist,
              oder bis Sie Ihre Einwilligung widerrufen.
            </p>
          </section>
          <section>
            <h2 className="text-neko-white font-semibold text-base mb-2">
              6. Ihre Rechte
            </h2>
            <p>
              Sie haben das Recht auf Auskunft, Berichtigung, Löschung und Datenübertragbarkeit
              gemäß DSGVO Art. 15–20. Kontakt: info@neko-bws.de
            </p>
          </section>
          <section>
            <p className="text-xs text-neko-gray/60">
              Hinweis: Partner-spezifische Datenschutzerklärungen werden über die Tenant-Konfiguration verlinkt.
            </p>
          </section>
        </div>
        <div className="mt-8">
          <a
            href="/"
            className="text-sm text-neko-gray hover:text-neko-white transition-colors"
          >
            ← Zurück zur Startseite
          </a>
        </div>
      </main>
    </div>
  );
}
